import { useQuery } from '@tanstack/react-query';
import { getSequenceNumber } from 'services/portfolios/portfolioService';

const useGetSequenceNumber = (brUid: string, accountType: string) => {
  return useQuery({
    queryKey: ['useGetSequenceNumber', brUid, accountType],
    queryFn: () => getSequenceNumber(brUid, accountType),
    enabled: !!brUid && !!accountType,
  });
};

export default useGetSequenceNumber;
